import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { BookingServiceRemoveAction, DashboardBookingMarkCompletedAction, DashboardBookingViewDetailAction, MarkAsCompletedAction } from '../../redux/Action/DashboardAction';
import { useLocation } from 'react-router-dom';
import { decodeID, getLastURL, handleInput } from '../../utils/Helper';
import Button from '../Ui/Button';
import { toNumber } from 'lodash';
import { FormattedMessage, useIntl } from 'react-intl';

const MarkCompleted = ({ serviceId }: any) => {
    const dispatch = useDispatch<any>();
    const intl = useIntl();
    const local_language = localStorage.getItem('lang')

    const dashboard_service_data = useSelector((state: any) => state.DashboardMarkAsCompletedState);
    const mark_as_completed = useSelector((state: any) => state.BookingMarkAsCompletedState);
    const [prices, setPrices]: any = useState({});

    const [errorMessage, setErrorMessage] = useState('');
    const handleChange = (e: any) => {
        let value = e.target.value.replace(/\s{2,}/g, ' ');

        if (value.length > 200) {
            value = value.substring(0, 200);
        }

        setPaymentMessage(value);

        if (value.length < 50) {
            return setErrorMessage(local_language == "alb" ? "Fletëpagesa duhet të jetë të paktën 50 karaktere." : 'Payment note must be at least 50 characters.');
        } else if (value.length > 200) {
            return setErrorMessage(local_language == "alb" ? 'Pagesa nuk mund të kalojë 200 karaktere' : 'Payment cannot exceed 200 characters');
            // return setErrorMessage('Payment cannot exceed 200 characters');
        } else {
            setErrorMessage('');
        }
    };


    const [divs, setDivs]: any = useState([]);
    const [totalMoney, setTotalMoney] = useState(0);
    const [service_id, setService_Id] = useState([])
    const [services, setServices]: any = useState({})

    const addDiv = () => {
        setDivs([...divs, { id: divs.length }]);
    };


    const removeDiv = (id: any) => {
        setDivs((prevDivs: any) => prevDivs.filter((div: any) => div.id !== id));

        setServices((prevServices: any) => {
            const newServices = { ...prevServices };
            delete newServices[id];
            return newServices;
        });



        setPrices((prevPrices: any) => {
            const newPrices = { ...prevPrices };
            delete newPrices[id];
            return newPrices;
        });

    };


    const combinedArray = Object.keys(services).filter(key => services[key] !== '' && prices[key] !== '').map(key => ({
        new_service_id: services[key],
        amount: prices[key]
    }));



    // const combinedArray = Object.keys(services).map(key => ({
    //     new_service_id: services[key],
    //     amount: prices[key]
    // }));




    const location = useLocation();
    const viewId = getLastURL(location);
    const params = { user_id: decodeID(viewId) };

    const booking_view_data = useSelector((state: any) => state.DashboardBookingViewDetailState);


    useEffect(() => {
        dispatch(DashboardBookingMarkCompletedAction({ serviceIds: service_id }))
    }, [])


    const [money, setMoney] = useState(0)
    useEffect(() => {
        setMoney(serviceId?.booking_details?.[0]?.amount ? serviceId?.booking_details?.[0]?.amount : 0)
    }, [serviceId])



    const handleServiceChange = (e: any, index: any) => {
        const selectedServiceId = e.target.value;
        const selectedService = dashboard_service_data?.data?.data.find((service: any) => service?.id == selectedServiceId)
        const price = selectedService ? selectedService.price : '0.00';

        setServices((prevPrices: any) => ({
            ...prevPrices,
            [index]: selectedServiceId
        }));

        setPrices((prevPrices: any) => ({
            ...prevPrices,
            [index]: price
        }));

    };

    useEffect(() => {
        const total: any = Object.values(prices).reduce((acc: any, price: any) => acc + price, 0);
        setTotalMoney(total);
    }, [prices]);



    const [uniqueServices, setUniqueServices] = useState([]);
    const getUniqueServices = (dashboardServices: any, bookingServices: any) => {
        return dashboardServices.filter((service: any) => bookingServices?.id != service?.id);
    };

    useEffect(() => {
        if (dashboard_service_data?.data?.data) {
            const uniqueServices = getUniqueServices(dashboard_service_data.data.data, serviceId?.booking_details?.[0]?.service_details || []);
            setUniqueServices(uniqueServices);
        }
    }, [dashboard_service_data, serviceId]);

    const [paymentMessage, setPaymentMessage] = useState("")

    const onSubmit = (e: any) => {
        e.preventDefault();


        if (paymentMessage.length < 50) {
            return setErrorMessage(local_language == "alb" ? "Fletëpagesa duhet të jetë të paktën 50 karaktere." : 'Payment note must be at least 50 characters.');
        } else if (paymentMessage.length > 200) {
            return setErrorMessage(local_language == "alb" ? 'Pagesa nuk mund të kalojë 200 karaktere' : 'Payment cannot exceed 200 characters');
        } else {
            setErrorMessage('');
        }

        const payload = {
            "booking_id": serviceId?.booking_details?.[0]?.booking_id,
            "total_amount": money,
            "user_id": serviceId?.id,
            "booking_service_id": serviceId?.booking_details?.[0]?.id,
            "payment_note": paymentMessage,
            "new_services": combinedArray?.length > 0 ? combinedArray : null,
        }
        dispatch(MarkAsCompletedAction(payload));
    };

    const addNewService = () => {
        // Find the first available index
        const usedIndices = new Set(divs.map((div: any) => div.id));
        let newId = 0;
        while (usedIndices.has(newId)) {
            newId++;
        }

        setDivs((prevDivs: any) => [...prevDivs, { id: newId, service: '', price: '' }]);
        setServices((prevServices: any) => ({ ...prevServices, [newId]: '' }));
        setPrices((prevPrices: any) => ({ ...prevPrices, [newId]: '' }));
    };



    useEffect(() => {
        if (mark_as_completed?.status) {
            $('.btnClose').click()
            $('.modal-backdrop').remove();
            dispatch(MarkAsCompletedAction("RESET"));
            setPaymentMessage("")
            setTotalMoney(0)
            setPrices([])
            setDivs([])
            setServices({})
        }

    }, [mark_as_completed])



    useEffect(() => {
        $('.btnClose').click()
        $('.modal-backdrop').remove();
        dispatch(MarkAsCompletedAction("RESET"));
        setPaymentMessage("")
        setTotalMoney(0)
        setDivs([])
        setPrices([])
        setServices({})

    }, [])

    const handleClose = () => {
        $('.btnClose').click()
        $('.modal-backdrop').remove();
        dispatch(MarkAsCompletedAction("RESET"));
        setPaymentMessage("")
        setTotalMoney(0)
        setDivs([])
        setPrices([])

        setServices({})
    }

    return (
        <>
            <div className="modal modelStyle fade" id="MarkToCompleted" tabIndex={-1} aria-labelledby="exampleModalLabel" data-bs-backdrop="static" aria-hidden="true" data-bs-keyboard="false">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h1 className="modal-title fs-5" id="exampleModalLabel">{<FormattedMessage id="Mark_as_Completed" />}</h1>
                            <button type="button" className="btn p-0 f-20 btnClose" data-bs-dismiss="modal" aria-label="Close"><span className="icon-close" onClick={handleClose}></span></button>
                        </div>
                        <form onSubmit={onSubmit}>
                            <div className="modal-body">
                                {/* {
                                serviceId?.booking_details?.[0]?.service_detail?.map((item: any, index: any) => {
                                    return (
                                        <> */}
                                <div className='Servicelist'>
                                    <div><span></span> {serviceId?.booking_details?.[0]?.service_details?.name ? serviceId?.booking_details?.[0]?.service_details?.name : "N/A"}
                                        <b className='ms-auto' >€{serviceId?.booking_details?.[0]?.amount ? serviceId?.booking_details?.[0]?.amount : "00.00"}</b>
                                        {/* <b className='ms-auto' >€{serviceId?.booking_details?.[0]?.service_details?.price ? serviceId?.booking_details?.[0]?.service_details?.price : "00.00"}</b> */}
                                    </div>
                                    {/* <span role='button' className="icon-close-full ms-3" onClick={() => handleRemoveService(item?.booking_id, serviceId?.id, item?.id)}></span> */}
                                </div> 

                                <div className='admoreservice'>
                                  
                                    {
                                        divs.map((div: any, index: any) => (
                                            <div key={div.id} className='row gy-2 gx-3 mb-3 align-items-center moreService'>
                                                <h6 className='marktitle'>{<FormattedMessage id="Add_New_Service" />}</h6>
                                                <div className='col-12 col-md-7 normalINput'>
                                                    <select
                                                        className={`form-select cat_select_${index}`}
                                                        onChange={(e) => handleServiceChange(e, div.id)}
                                                        value={services[div.id] || ""}
                                                    >
                                                        <option value="">Select Service</option>
                                                        {
                                                            uniqueServices?.length > 0 && uniqueServices?.map((item: any) => (
                                                                <option key={item?.id} value={item?.id}>{item?.name}</option>
                                                            ))}
                                                    </select>
                                                </div>
                                                <div className='col normalINput normalINputIcon'>
                                                    <span className='priceSIgn'>€</span>
                                                    <input type='text' className='form-control' placeholder='0.00' value={prices[div.id] || '0.00'} readOnly />
                                                </div>
                                                <div className='col-auto'>
                                                    <span onClick={() => removeDiv(div?.id)} role='button' className="icon-close-full f-18 ms-3"></span>
                                                </div>
                                            </div>
                                        ))}
                                </div>
                                <p role='button' onClick={addNewService} className='color-p addMoreBTN my-4 text-center'><i className="icon-plus-full"></i> <FormattedMessage id="Add_New_Service" /></p>
                                <div className='paymentInfomation my-4'>
                                    <h6 className='marktitle'>{<FormattedMessage id="Payment_Information" />}:</h6>
                                    <div className='total d-flex justify-content-between'>
                                        <strong>{<FormattedMessage id="Total" />}</strong>
                                        <strong>€ {money || totalMoney ? (Number(money) + Number(totalMoney)) : "00"}.00</strong>
                                    </div>
                                </div>
                                <div className='paymentNotes normalINput'>
                                    <h6 className='marktitle'>{<FormattedMessage id="Payment_Note" />}:</h6>
                                    <input type='text' className='form-control'
                                        // placeholder={<FormattedMessage id="Add_payment_note" /> as any}
                                        placeholder={intl.formatMessage({ id: 'Add_payment_note' })}
                                        value={paymentMessage}
                                        onChange={handleChange}></input>
                                    {errorMessage && <p style={{ color: 'red' }}>{errorMessage}</p>}

                                </div> 
                                {
                                    mark_as_completed?.loading ? <Button type='ssssubmit' className='btn btn-fill w-100 mt-4' isLoading={mark_as_completed?.loading} text='Submit' /> :
                                        <button type='submit' className='btn btn-fill w-100 mt-4' onSubmit={onSubmit}><FormattedMessage id="submit" /></button>

                                }
                            </div>

                        </form>

                    </div>
                </div >
            </div >
        </>
    )
}

export default MarkCompleted